import * as Sentry from '@sentry/react';
import { userStore } from '@stores/User';
import { observer } from 'mobx-react';
import { ReactNode } from 'react';
import './ErrorBoundary.module.scss';

type ErrorCatcherProps = {
  showDialog?: boolean;
};
export const ErrorCatcher = observer(
  ({ children, showDialog = false }: ErrorCatcherProps & { children: ReactNode }) => {
    const email = userStore.data?.email ?? '';
    const name =
      userStore.data?.name?.nickname ??
      userStore.data?.name?.first ??
      email.split('@')[0].split(/[.-_+]/)[0];

    return (
      <Sentry.ErrorBoundary
        showDialog={showDialog}
        dialogOptions={{
          title: 'Oops!',
          subtitle: "We've been notified and will fix this as soon as possible.",
          subtitle2: 'Help us understand what happened.',
          labelName: 'Name',
          labelEmail: 'Email',
          labelComments: 'Comments',
          labelClose: "Don't send",
          labelSubmit: 'Send my feedback',
          errorGeneric: 'An error occurred',
          user: { email, name },
          onClose() {
            location.reload();
          },
        }}
      >
        {children}
      </Sentry.ErrorBoundary>
    );
  },
);
